import { Checkbox, type CheckboxOptionType } from 'antd';
import type { DataTypes } from '@/types';
import type {
  BreakdownBySectionProps,
  CheckboxField,
  DownloadSettingsState,
} from './downloadDrawer.d';
import DrawerSectionEcho from './DrawerSectionEcho';

const checkboxFields: CheckboxField[] = [
  {
    name: 'shows',
    label: 'Shows report',
    description: 'Show, Impressions, Earnings by campaign type, Total earnings, Currency',
  },
  {
    name: 'campaign_types',
    label: 'Campaign types report',
    description: 'Campaign type, Impressions, Earnings, Currency',
  },
  {
    name: 'advertisers',
    label: 'Advertisers report',
    description: 'Advertiser, IAB Categories, Earnings, Currency',
  },
  {
    name: 'campaigns',
    label: 'Individual campaigns report',
    description:
      'Campaign type, Show, Advertiser, Campaign Start & End dates, Impressions, Earnings, Currency',
  },
];

const includeKeys = checkboxFields.map((field) => field.name) as DataTypes[];

const checkboxOptions: CheckboxOptionType<string>[] = checkboxFields.map((field) => ({
  value: field.name,
  label: (
    <span className="flex flex-col gap-1">
      <span>{field.label}</span>
      <span className="text-sm text-slate-600">{field.description}</span>
    </span>
  ),
}));

const ReportsToDownloadSection = ({
  downloadSettings,
  setDownloadSettings,
}: BreakdownBySectionProps) => {
  const checkedValues = includeKeys.filter((key) => downloadSettings.include[key]);

  const handleGroupChange = (nextChecked: string[]) => {
    setDownloadSettings((prev: DownloadSettingsState) => ({
      ...prev,
      include: {
        shows: nextChecked.includes('shows'),
        campaign_types: nextChecked.includes('campaign_types'),
        advertisers: nextChecked.includes('advertisers'),
        campaigns: nextChecked.includes('campaigns'),
      },
    }));
  };

  return (
    <DrawerSectionEcho title="Reports to download" aria-label="Reports to download">
      <Checkbox.Group
        className="flex flex-col gap-3 [&_.ant-checkbox-wrapper]:items-start [&_.ant-checkbox]:!self-start"
        options={checkboxOptions}
        value={checkedValues}
        onChange={handleGroupChange}
      />
    </DrawerSectionEcho>
  );
};

export default ReportsToDownloadSection;
